import { render } from "./iconDialog.vue?vue&type=template&id=79b79bbc&scoped=true"
import script from "./iconDialog.vue?vue&type=script&lang=js"
export * from "./iconDialog.vue?vue&type=script&lang=js"

import "./iconDialog.vue?vue&type=style&index=0&id=79b79bbc&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b79bbc"]])

export default __exports__